module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S9 Coral Blue.35822538.png";